module.exports = __webpack_public_path__ + "static/media/footer-sprite.2066a628.svg";